import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChartWithHeader from './../../component/chartWithHeader'
import Service from './service';
import Select from './../../component/select/';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false,
        selectedSignUpsInterval: 30,
        intervalOptions : [
            {displayText: 'Select Interval', value: 30},
            {displayText: 'One Month', value: 30},
            {displayText: 'Two Months', value: 60},
            {displayText: 'Three Months', value: 90}
        ]
    }

    componentDidMount () {
        Service.event.onFetchCountryStatsByRevenue.add((chartData) => {
            this.setState({
                histogramChartCategoriesList: chartData.categoryList,
                histogramChartSeriesDataList1: chartData.revenueSeriesData,
                histogramChartSeriesDataList2: chartData.signUpSeriesData,
                histogramChartSeriesDataList3: chartData.packageSeriesData,
                histogramChartSeriesDataList4: chartData.shipmentSeriesData,
                histogramChartSeriesDataList5: chartData.newPackageSeriesData,
                histogramChartSeriesDataList6: chartData.newShipmentSeriesData,
                renderChart : true,
            });
        });

        Service.fetchCountryStatsByRevenue(this.state.selectedSignUpsInterval);
    }

    componentWillUnmount() {

    }

    selectElementChange = (event) => {
        this.setState({ selectedSignUpsInterval: event.target.value});
        Service.fetchCountryStatsByRevenue(event.target.value);
    };

    // refresh button actions
    searchButtonAction = () => {
        Service.fetchCountryStatsByRevenue(this.state.selectedSignUpsInterval);
    };

    render() {
        return (
            <div>
                <div className = "portlet box blue-hoki">
                    <div className = "portlet-title p-l-r-10">
                        <div className="caption">
                            <i className="fa fa-credit-card"></i>
                            Top Country (top 20) by revenue</div>
                        <div className="actions">
                             <Select className={"packages-status-dropdown"}
                                    controlFunc={this.selectElementChange}
                                    options = {this.state.intervalOptions}>
                            </Select>
                            <input type="button" value="Refresh" className="button-right btn-info" onClick={this.searchButtonAction} />

                        </div>
                    </div>
                </div>
                <div>
                    { this.state.renderChart ? <CustomChartWithHeader
                        chartTitle = {"Top Country (top 20) by revenue for last " + this.state.selectedSignUpsInterval + " days"}
                        histogramChartCategoriesList = {this.state.histogramChartCategoriesList}
                        histogramChartSeriesDataList1 = {this.state.histogramChartSeriesDataList1}
                        histogramChartSeriesDataList2 = {this.state.histogramChartSeriesDataList2}
                        histogramChartSeriesDataList3 = {this.state.histogramChartSeriesDataList3}
                        histogramChartSeriesDataList4 = {this.state.histogramChartSeriesDataList4}
                        histogramChartSeriesDataList5 = {this.state.histogramChartSeriesDataList5}
                        histogramChartSeriesDataList6 = {this.state.histogramChartSeriesDataList6}
                    /> : '' }
                </div>
            </div>
        );
    }
}

export default ChartView;